export default "__VITE_ASSET__Ddt8qo4h__"